import type { AnswerForType } from "@tellescope/types-models";
import type { TellescopeFieldResponse } from "../types";

export const getLatestInsuranceAnswer = (
  responses: TellescopeFieldResponse[]
): AnswerForType["Insurance"] | undefined => {
  let result: AnswerForType["Insurance"] | undefined;
  for (const r of responses) {
    if (r.answer?.type === "Insurance" && r.answer.value?.payerId) {
      result = r.answer.value;
    }
  }
  return result;
};

export const getLatestAddressAnswer = (responses: TellescopeFieldResponse[]): AnswerForType["Address"] | undefined => {
  let result: AnswerForType["Address"] | undefined;
  for (const r of responses) {
    if (r.answer?.type === "Address") {
      result = r.answer.value;
    }
  }
  return result;
};

/**
 * The **first** Insurance answer carrying a payerId, in response order.
 *
 * Eligibility checks read the first such answer rather than the last: a form that asks about
 * insurance more than once (e.g. primary then secondary) means the earlier question to be the one
 * eligibility is run against.
 */
export const getFirstInsuranceAnswer = (
  responses: TellescopeFieldResponse[]
): AnswerForType["Insurance"] | undefined => {
  const match = responses.find((r) => r.answer?.type === "Insurance" && !!r.answer.value?.payerId);
  return match?.answer?.type === "Insurance" ? match.answer.value : undefined;
};

/** The **first** Address answer carrying a truthy state, in response order. */
export const getFirstAddressAnswerWithState = (
  responses: TellescopeFieldResponse[]
): AnswerForType["Address"] | undefined => {
  const match = responses.find((r) => r.answer?.type === "Address" && !!r.answer.value?.state);
  return match?.answer?.type === "Address" ? match.answer.value : undefined;
};

export const getLatestBridgeEligibilityAnswer = (
  responses: TellescopeFieldResponse[]
): AnswerForType["Bridge Eligibility"] | undefined => {
  let result: AnswerForType["Bridge Eligibility"] | undefined;
  for (const r of responses) {
    if (r.answer?.type === "Bridge Eligibility" && r.answer.value?.userIds?.length) {
      result = r.answer.value;
    }
  }
  return result;
};
